/** @format */

import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Injectable, inject, makeStateKey, PLATFORM_ID, TransferState } from '@angular/core';
import { Chain, Environment } from '@shared/data-access/interfaces';

import { Logger } from '@shared/data-access/services';
import { CustomHttpHeaders } from '@shared/data-access/enums';
import { Observable, throwError } from 'rxjs';
import { catchError, map, retry } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class KrakenService {
  readonly KRAKEN_URL: string;
  protected readonly platformId = inject(PLATFORM_ID);
  private readonly http = inject(HttpClient);
  private readonly state = inject(TransferState);
  private readonly chain = inject(Chain);
  private readonly environment = inject(Environment);
  private readonly logger = inject(Logger);
  constructor() {
    this.KRAKEN_URL = this.environment.api.kraken.gatewayUrlProxy.path;
  }

  get(name: string, retries = 0): Observable<string> {
    const ELEMENT_KEY = makeStateKey(`kraken-${name}-${this.chain.chainMarketingIdentifierAbbr}`);
    const element: any = this.state.get(ELEMENT_KEY, null);

    if (element) {
      return new Observable((o) => {
        o.next(element);
        o.complete();
      });
    }

    const template_url = `${this.KRAKEN_URL}/p/${name}/${this.chain.chainMarketingIdentifierAbbr}`;

    let httpHeaders = new HttpHeaders({
      'X-TIMEOUT': '3000',
    });

    // Custom HTTP Headers
    httpHeaders = httpHeaders.set(CustomHttpHeaders.X_PROXY_REQUEST, 'true');

    // HTTP Options
    const httpOptions = {
      headers: httpHeaders,
      responseType: 'text' as const,
    };

    return this.http.get(template_url, httpOptions).pipe(
      map((response: any) => {
        this.state.set(ELEMENT_KEY, response);
        return response;
      }),
      retry(retries),
      catchError((error: HttpErrorResponse) => {
        this.logger.error('Error getting data from kraken', error);
        return throwError(() => error);
      }),
    );
  }
}
